﻿import React from 'react';
import { Checkbox } from '../';
import styled from 'styled-components';

interface ITableBodyCellContentCheckProps {
    selected: boolean;
    onClick: () => void;
}

const CellContent = styled.div`
    margin-top: -3px;
    text-align: center;
`

export const TableBodyCellContentCheck: React.FunctionComponent<ITableBodyCellContentCheckProps> = (props) => {
    return (<CellContent>
        <Checkbox checked={props.selected} onChange={props.onClick} />
    </CellContent>);
}